import { Card } from '@mui/material'
import { styled } from '@mui/material/styles'

export const CardBox = styled(Card)({
  width: '100%',
  height: '100%',
  border: '1px solid #E0E0E0',
  borderRadius: '10px',
  boxShadow: '0px 10px 10px #00000029',
})
